import * as React from 'react';
import {Container, Image, Add} from './styles';
import logo from '../../../assets/logos/logoTopii.svg';
import logoFihogar from '../../../assets/logos/logo-fihogar.png'


interface Props {
  src?: string;
  width?: number;
  height?: number;
}

const LogoTopiiTigo: React.FC<Props> = ({src = logo, width = 120, height = 50}) => {
  return (
    <Container>
      <Image src={src} width={width} height={65} />
      <Image src={logoFihogar} width={120} height={75} />
    </Container>
  );
};

export default LogoTopiiTigo;
